import { Text } from "@aurem/ui";
import { AuremLogo } from "components/Logo";
import ROUTES from "const/routes";
import useAnalytics, { AnalyticsEvent } from "hooks/useAnalytics";
import { Loader2, Mail } from "lucide-react";
import { AuthStatus, useAuth } from "providers/AuthProvider";
import { useI18n } from "providers/I18nProvider";
import { memo, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

const SamlRedirect = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setAuthState } = useAuth();
  const { track } = useAnalytics();
  const { t } = useI18n();
  useEffect(() => {
    const accessToken = params.get("accessToken");
    const refreshToken = params.get("refreshToken");
    if (accessToken && refreshToken) {
      setAuthState({
        accessToken,
        refreshToken,
        status: AuthStatus.Authenticated,
      });
      track(AnalyticsEvent.SignInBySaml);
      const from = params.get("routeAfterAuth");
      void navigate("/", { state: { from } });
    }
  }, [params]);

  return (
    <div className="max-w-md p-6 max-sm:px-0">
      <div className="max-sm:px-6">
        <Link to={"/" + ROUTES.ROOT}>
          <AuremLogo width={107} />
        </Link>
      </div>
      <div className="rounded-lg border border-neutral-500/10 bg-white shadow-md my-6 max-sm:rounded-none">
        <Loader2 size={200} className="mx-auto animate-spin" />
      </div>
      <div className="flex flex-row items-center justify-between gap-4 px-4 text-sm text-gray500 max-sm:flex-col max-sm:px-6">
        <Text>{t("apps.admin.common.tagline")}</Text>
        <div className="flex flex-row items-center">
          <Mail size="18px" />
          <a
            className="ms-2"
            href={`mailto:${t("apps.admin.common.helpEmail")}`}
          >
            {t("apps.admin.common.helpEmail")}
          </a>
        </div>
      </div>
    </div>
  );
};
export default memo(SamlRedirect);
